export { default as VictoryBrushLine } from "./victory-brush-line";


//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-line/es/index.js
// module id = ./node_modules/victory-brush-line/es/index.js
// module chunks = 1